import commonText from './commonContents'


export default {
    ...commonText,
    'uaePassSessionInvalidated': 'Previous session is no longer valid. Please try again by clicking on above button.',
    "login_heading": "Login to your account",
    "login_subheading": "Welcome back! Please enter your details.",
    "uaeBtnText": "Login with UAE PASS",
    "orSperatorText": "or",
    "forgotPasswordLabelText": "Forgot Password?",
    "termConditions": "I agree to all the terms and conditions",
    "submitButtonText": "Login",
    "auth_unsuccessful": "Please provide valid details and try again",
    "UAEPassLoginCancelled": "User cancelled the login",
    "UAEPassInvalidCustomerText": "This service is only for registered users, please contact 800ALDAR in order to access the services",
    "notSOP3Text": "You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact 800-25327 to access the services.",
    "fields": {
        mail: {
            label: 'Email',
            requiredErrorMessage: commonText.requiredErrorMessage,
            formatErrorMessage: commonText.formatErrorMessage
        },
        password: {
            label: 'Password',
            requiredErrorMessage: commonText.requiredErrorMessage
        },
        rememberMe: {
            label: 'Remember Me',
            requiredErrorMessage: commonText.requiredErrorMessage
        },
        terms: {
            label: 'I agree to all the terms and conditions',
            requiredErrorMessage: commonText.requiredErrorMessage
        },
    }
}